export default __webpack_public_path__ + "static/Boston-57550762d5548451f648742fd11c2d1a.webp";